import { SvgPropType } from './types/svgPropType';

function SocialPeopleIcon({ width, height }: SvgPropType) {
    return (
        <svg width={width || '30'} height={height || '21'} viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 10.5C11.9016 10.5 14.25 8.15156 14.25 5.25C14.25 2.34844 11.9016 0 9 0C6.09844 0 3.75 2.34844 3.75 5.25C3.75 8.15156 6.09844 10.5 9 10.5ZM12.6 12H12.2109C11.2359 12.4688 10.1531 12.75 9 12.75C7.84688 12.75 6.76875 12.4688 5.78906 12H5.4C2.41875 12 0 14.4188 0 17.4V18.75C0 19.9922 1.00781 21 2.25 21H15.75C16.9922 21 18 19.9922 18 18.75V17.4C18 14.4188 15.5812 12 12.6 12ZM22.5 10.5C24.9844 10.5 27 8.48438 27 6C27 3.51562 24.9844 1.5 22.5 1.5C20.0156 1.5 18 3.51562 18 6C18 8.48438 20.0156 10.5 22.5 10.5ZM24.75 12H24.5719C23.9203 12.225 23.2313 12.375 22.5 12.375C21.7687 12.375 21.0797 12.225 20.4281 12H20.25C19.2938 12 18.4125 12.2766 17.6391 12.7219C18.7828 13.9547 19.5 15.5906 19.5 17.4V19.2C19.5 19.3031 19.4766 19.4016 19.4719 19.5H27.75C28.9922 19.5 30 18.4922 30 17.25C30 14.3484 27.6516 12 24.75 12Z" fill="url(#paint0_linear_3721_9109)"/>
            <defs>
                <linearGradient id="paint0_linear_3721_9109" x1="15" y1="0" x2="15" y2="21" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFAFBF"/>
                    <stop offset="0.956324" stopColor="#9747FF"/>
                </linearGradient>
            </defs>
        </svg>
    );
}

export default SocialPeopleIcon;
